import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TeacherFilter from "../Props/TeacherFilter";
import TeacherProps from "../Props/TeacherProps";
import TeacherPreview from "../components/TeacherPreview";
import ReactPaginate from "react-paginate";
import { TEACHER_FETCH_START, TEACHER_FETCH_SUCCESS, TEACHER_TOTAL_PAGE } from "../Reducer/teacherSlice";
import API from "../Network/API";
import { useLocation } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

export default function TeacherList() {
  const { t } = useTranslation();
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");
  const select_teachers = useSelector((state) => state.teacherReducer);
  const [currentPage, setCurrentPage] = useState(0);
  const [keyword, setKeyword] = useState('');
  const dispatch = useDispatch();
  const [speak, setSpeak] = useState(0);
  const [category, setCategory] = useState(0);
  const [country, setCountry] = useState('');
  const [gender, setGender] = useState('');

  const teachers = select_teachers?.teachers || [];
  const listRef = useRef(null);
  const [previewId, setPreviewId] = useState(null);
  const [previewTop, setPreviewTop] = useState(0);
  const preview = teachers.find((teacher) => teacher.id === previewId) || teachers[0];

  // Align the preview panel with the hovered card.
  const handleHover = (teacher, el) => {
    setPreviewId(teacher.id);
    setPreviewTop(el ? el.offsetTop : 0);
  };

  useEffect(() => {
    setPreviewId(null);
    setPreviewTop(0);
  }, [select_teachers?.teachers]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const handleCategory=(categoryId)=>{
    setCategory(categoryId);
  }

  const handleSpeak=(langId)=>{
    setSpeak(langId);
  }

  const handleCountry=(conId)=>{
    setCountry(conId);
  }

  const handleGender=(conId)=>{
    setGender(conId);
  }

  useEffect(() => {
    const fetchCourses = () => {
      dispatch(TEACHER_FETCH_START())
      const pageQuery = currentPage > 0 ? `&page=${currentPage + 1}` : '';
      const q=keyword==null?'':keyword;
      API.get(`/v1/oauth/all_teachers?keyword=${q}${pageQuery}&country=${country}&category=${category}&speak=${speak}&gender=${gender}`)
        .then((response) => {
          dispatch(TEACHER_FETCH_SUCCESS(response.data.data));
          dispatch(TEACHER_TOTAL_PAGE(response.data.data.total_page));
        })
        .catch((error) => {

        });
    };

    fetchCourses();

  }, [currentPage,keyword,speak,category,country,gender]);



  return (
    <>
      <div className="InstructorPage">
        <div className="teacherWrapperTop">
          <div className="container">
            <div className="InstructorIntro">
              <div className="row">
                <div className="col-md-7">
                  <div className="intro-heading">
                    <h2 className="title"><Trans i18nKey="teacherList.find_your_teacher" components={{ span: <span /> }} /></h2>
                    <p className="mb-0 dec mt-2">
                      {t("teacherList.intro_description")}
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="banner-image d-flex justify-content-end">
                    <img className="img-fluid" src="/assets/img/teacherInter.svg" alt={t("teacherList.alt_shape")} />
                  </div>
                </div>
              </div>
              <div className="row justify-content-between mt-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="dropdown dropdown-large">
            <a className="btn btn-white btn-dropdown-white rounded-pill dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <h5 className="mb-0 d-inline">{t("teacherList.all_tutors")}</h5>
            </a>
           
          </div>
          <div className="top-search-area">
            <div className=" search-group">
              <i className="fa-light fa-search" />
              <input type="text" className="form-control rounded-pill form-control-lg" placeholder={t("teacherList.search_placeholder")} onKeyUp={(e)=>setKeyword(e.target.value)}/>
            </div>
          </div>
        </div>
      </div>
            </div>
          </div>
        </div>
        <div className="teacherWrapperBottom">
          <div className="container">
            <div className="showing-list">
              <TeacherFilter handleCategory={handleCategory} handleSpeak={handleSpeak} handleCountry={handleCountry} handleGender={handleGender}/>
            </div>
            <div className="InstructorList">
              <div className="row">
                <div className="col-lg-8">
                  <div className="tutor-list" ref={listRef}>
                    {!select_teachers?.loading && teachers.map((teacher) => (
                      <TeacherProps
                        key={teacher.id}
                        data={teacher}
                        active={preview?.id === teacher.id}
                        onHover={handleHover}
                      />
                    ))}
                  </div>

                  <div className="mt-3 ms-3">
                    <ReactPaginate
                      pageCount={select_teachers?.total_page}
                      onPageChange={handlePageChange}
                      forcePage={currentPage}
                      containerClassName={'pagination'}
                      previousLinkClassName={'page-link'}
                      breakClassName={'page-link'}
                      nextLinkClassName={'page-link'}
                      pageClassName={'page-item'}
                      pageLinkClassName="page-link"
                      disabledClassName={'disabled'}
                      activeClassName={'active'}
                    />
                  </div>
                </div>
                <div className="col-lg-4 d-none d-lg-block">
                  <TeacherPreview data={preview} top={previewTop} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}